import ModalClass from "common/utils/ui/modal-class";
import EventClass from "common/utils/ui/event-class";
import initFavoriteIcon from "components/jiffy/line-item-favorite-icon/line-item-favorite-icon";
import initDeliveryDateSimple from "components/jiffy/product-details-delivery-date-simple/product-details-delivery-date-simple";
import { BuyItAgainDtfBuy } from "./buy-it-again-dtf-buy";
import "./buy-it-again-dtf-modal.scss";

export class BuyItAgainDtfModal extends ModalClass {
  #submit;

  #qtyInputEvent;

  #decreaseEvent;

  #increaseEvent;

  constructor(options) {
    super(options);

    this.#initEvents(options.modalSelector);
    this.#submit = new BuyItAgainDtfBuy({
      eventSelector: `${options.modalSelector} .js-submit`,
      getQty: () => this.#qtyValue,
      eventCallback: this.closeModal.bind(this)
    });
  }

  get #qtyValue() {
    return parseInt(this.$modal.querySelector(".js-qty").value, 10) || 1;
  }

  set #qtyValue(value) {
    this.$modal.querySelector(".js-qty").value = Math.max(1, value);
  }

  #fillModal(payload) {
    this.$modal
      .querySelectorAll(".js-link")
      .forEach($link => $link.setAttribute("href", payload.productUrl));
    this.$modal.querySelector(".js-brand-url").setAttribute("href", payload.brandUrl);
    this.$modal.querySelector(".js-brand-logo").setAttribute("src", payload.brandLogo);
    this.$modal.querySelector(".js-preview").setAttribute("src", payload.preview);
    this.$modal.querySelector(".js-title").textContent = payload.productName;
    this.$modal.querySelector(".js-width").textContent = payload.width;
    this.$modal.querySelector(".js-height").textContent = payload.height;
    this.$modal.querySelector(".js-width-input").value = payload.width;
    this.$modal.querySelector(".js-catalog-number").textContent = payload.catalogNumber;
    this.$modal.querySelector(".js-height-input").value = payload.height;
    this.#qtyValue = 1;
  }

  #inputQty() {
    this.#qtyValue += 0; // Just checking qty. Ensure qtyValue is at least 1
    this.#handleDecreaseButtonState();
  }

  #decreaseQty() {
    this.#qtyValue -= 1;
    this.#handleDecreaseButtonState();
  }

  #increaseQty() {
    this.#qtyValue += 1;
    this.#handleDecreaseButtonState();
  }

  #handleDecreaseButtonState() {
    const $decreaseButton = this.$modal.querySelector(".js-decrease");

    if (this.#qtyValue <= 1) {
      $decreaseButton.setAttribute("disabled", "disabled");
    } else {
      $decreaseButton.removeAttribute("disabled");
    }
  }

  #initEvents(wrapperSelector) {
    this.#qtyInputEvent = new EventClass({
      eventSelector: `${wrapperSelector} .js-qty`,
      event: "blur",
      eventCallback: this.#inputQty.bind(this),
      eventOptions: { passive: true }
    });

    this.#decreaseEvent = new EventClass({
      eventSelector: `${wrapperSelector} .js-decrease`,
      event: "click",
      eventCallback: this.#decreaseQty.bind(this),
      eventOptions: { passive: true }
    });

    this.#increaseEvent = new EventClass({
      eventSelector: `${wrapperSelector} .js-increase`,
      event: "click",
      eventCallback: this.#increaseQty.bind(this),
      eventOptions: { passive: true }
    });
  }

  #initFavorite(favorite) {
    const $iconOld = this.$modal.querySelector(".js-favorite:not(.hidden)");
    $iconOld?.remove();

    const $iconTemplate = this.$modal.querySelector(".js-favorite.hidden");
    const $icon = $iconTemplate.cloneNode(true);
    $iconTemplate.parentNode.insertBefore($icon, $iconTemplate);

    $icon.classList.toggle("line-item-favorite-icon--added", favorite.is_favorited);
    $icon.classList.add("js-line-item-favorite-icon");
    $icon.classList.remove("hidden");

    $icon.dataset.favoriteColor = favorite.favorite_color;
    $icon.dataset.favoriteCompositionId = favorite.favorite_composition_id;
    $icon.dataset.isFavorited = favorite.is_favorited;
    $icon.dataset.productId = favorite.product_id;
    $icon.dataset.productStyle = favorite.product_style;
    $icon.dataset.brand = favorite.brand;
    $icon.dataset.productName = favorite.product_name;
    $icon.dataset.compositionInventoryRank = favorite.composition_inventory_rank;
    $icon.dataset.shippingRule = favorite.shipping_rule;
    $icon.dataset.adwordsCategory = favorite.adwords_category;
    $icon.dataset.buttonDisplayType = favorite.button_display_type;
    $icon.dataset.businessLine = favorite.business_line;
    $icon.dataset.businessLineId = favorite.business_line_id;

    initFavoriteIcon();
  }

  async #loadDeliveryDate(productUrl, lineItemId, lineItemSlug) {
    try {
      const $deliveryDateContainer = this.$modal.querySelector(
        "#js-product-details-delivery-dates-simple-container"
      );
      if ($deliveryDateContainer) {
        // Use the product slug for the delivery date API
        const productSlug = lineItemSlug || String(lineItemId).replace(/\.html$/, "");

        // Set all necessary data attributes before initializing
        $deliveryDateContainer.dataset.productId = productSlug;
        $deliveryDateContainer.dataset.selectedColor = "Transfer";
        $deliveryDateContainer.dataset.assignable = "true";
        $deliveryDateContainer.dataset.isDtf = "true";

        // Initialize the delivery date component
        await initDeliveryDateSimple();
      }
    } catch (error) {
      console.error("Failed to load delivery date:", error);
    }
  }

  openModal({ favorite, ...data }) {
    super.openModal();

    this.#submit.variantId = data.variantId;
    this.#submit.dtfPrintId = data.dtfPrintId;
    this.#submit.productId = data.lineItemId;
    this.#fillModal(data);
    this.#initFavorite(favorite);

    // Load delivery date component with proper product ID
    if (data.productUrl && data.lineItemId) {
      this.#loadDeliveryDate(data.productUrl, data.lineItemId, data.lineItemSlug);
    }
  }
}

export default props =>
  new BuyItAgainDtfModal({
    modalSelector: "#buy-it-again-dtf-modal",
    ...props
  });
